


var menu = []

localStorage.getItem("urole") === "16" ?
    menu = [

        {
            icon: "dashboard",
            text: "User Dashboard",
            link: "/Dashboard",
            active: false,


        },
        {
            icon: "user",
            text: "ES Return",
            link: "/Dashboard",
            active: false,


        },
        {
            icon: "user-add",
            text: "CP1",
            link: "/CPdashboard",
            active: false,


        },/*
        {
            icon: "user-list-fill",
            text: "ER",
            link: "/ERDashboard",
            active: false,


        }
*/


    ] :

    localStorage.getItem("urole") === "7" ?
        menu = [
            {
                icon: "account-setting-fill",
                text: "ES Dashboard",
                active: false,
                subMenu: [
                    {
                        icon: "dashboard",
                        text: "DGE Dashboard",
                        link: "/DGEDashboard",
                        active: false,



                    },
                    {
                        icon: "ni ni-reports",
                        text: "Main Report",
                        link: "/AdminEmployemtCount",
                        active: false,



                    },
                    {
                        icon: "ni ni-repeat-fill",
                        text: "Pending Request",
                        link: "/Recheck",
                        active: false,


                    }
                ]

            },
            {
                icon: "user-check-fill",
                text: "MIS ES Report",
                active: false,
                subMenu: [
                    {
                        icon: "blank-fill",
                        text: "ES1Report",
                        link: "/ES1Report",
                        active: false,

                    },
                    {
                        icon: "cards-fill",
                        text: "ES2Report",
                        link: "/ES2Report",
                        active: false,

                    },
                    {
                        icon: "bag-fill",
                        text: "ES3Report",
                        link: "/ES3Report",
                        active: false,


                    },

                    {
                        icon: "cc-alt-fill",
                        text: "ES4Report",
                        link: "/ES4Report",
                        active: false,

                    },

                    {
                        icon: "grid",
                        text: "ES5Part1Report",
                        link: "/ES5Part1Report",
                        active: false,

                    },
                    {
                        icon: "spark-fill",
                        text: "ES5Part2Report",
                        link: "/ES5Part2Report",
                        active: false,

                    },
                    {
                        icon: "todo-fill",
                        text: "ES6DataReport",
                        link: "/ES6DataReport",
                        active: false,

                    },
                    {
                        icon: "grid-box-alt",
                        text: "ES7DataReport",
                        link: "/ES7DataReport",
                        active: false,

                    },
                    {
                        icon: "speed",
                        text: "ES8DataReport",
                        link: "/ES8DataReport",
                        active: false,

                    },

                ]

            },
            {
                icon: "setting  ",
                text: "CP Dashboard",
                active: false,
                subMenu: [
                    {
                        icon: "dashboard",
                        text: "CP DGE Dashboard",
                        link: "/CPDGEdashboard",
                        active: false,



                    },
                    {
                        icon: "cards-fill",
                        text: "MIS CP Report",
                        link: "/cp1report",
                        active: false,

                    },
                   {
                        icon: "ni ni-repeat-fill",
                        text: "Pending Request",
                        link: "/cprecheck",
                        active: false,

                    },
                   

                ]

            },
            


            /*   {
                   icon: "dashboard",
                   text: "DGE Dashboard",
                   link: "/DGEDashboard",
                   active: false,
   
   
               },
               {
                   icon: "ni ni-reports",
                   text: "Report",
                   link: "/AdminEmployemtCount",
                   active: false,
   
   
               },
               {
                   icon: "ni ni-repeat-fill",
                   text: "Pending Request",
                   link: "/Recheck",
                   active: false,
   
   
               },
               {
                   icon: "blank-fill",
                   text: "ES1Report",
                   link: "/ES1Report",
                   active: false,
   
               },
               {
                   icon: "cards-fill",
                   text: "ES2Report",
                   link: "/ES2Report",
                   active: false,
   
               },
               {
               icon: "bag-fill",
               text: "ES3Report",
               link: "/ES3Report",
               active: false,
   
   
           },
   
           {
               icon: "cc-alt-fill",
               text: "ES4Report",
               link: "/ES4Report",
               active: false,
   
           },
           
           {
               icon: "grid",
               text: "ES5Part1Report",
               link: "/ES5Part1Report",
               active: false,
   
           },
           {
               icon: "spark-fill",
               text: "ES5Part2Report",
               link: "/ES5Part2Report",
               active: false,
   
           },
           {
               icon: "todo-fill",
               text: "ES6DataReport",
               link: "/ES6DataReport",
               active: false,
   
           },
            {
               icon: "grid-box-alt",
               text: "ES7DataReport",
               link: "/ES7DataReport",
               active: false,
   
           },
            {
               icon: "speed",
               text: "ES8DataReport",
               link: "/ES8DataReport",
               active: false,
   
           },
   */

        ] :

        localStorage.getItem("urole") === "8" ?
            menu = [

                {
                    icon: "dashboard",
                    text: "ES State Dashboard",
                    link: "/State-Dashboard",
                    active: false,


                },
                {
                    icon: "grid-plus",
                    text: "CP State Dashboard",
                    link: "/CPStatedashboard",
                    active: false,


                },



            ] :
            localStorage.getItem("urole") === "9" ?
                menu = [

                    {
                        icon: "grid-plus",
                        text: "ES Regional Dashboard",
                        link: "/Reasonal-Dashboard",
                        active: false,


                    },
                    {
                        icon: "dashboard",
                        text: "CP Regional Dashboard",
                        link: "/CPRegionaldashboard",
                        active: false,


                    },





                ] :
                localStorage.getItem("urole") === "6" ?
                    menu = [
                        {
                            icon: "dashboard",
                            text: "Add User",
                            link: "/Add-Detail",
                            active: false,


                        },

                    ] :
                    menu = [

                        {
                            icon: "dashboard",
                            text: "User Dashboard",
                            link: "/Dashboard",
                            active: false,


                        },
                        {
                            icon: "user",
                            text: "Employment Statistics",
                            link: "/Dashboard",
                            active: false,


                        },
                        {
                            icon: "account-setting-fill",
                            text: "Employment Return",
                            active: false,
                            subMenu: [
                                {
                                    text: "EMI Returns",
                                    link: "/UndererDev",



                                },

                                {
                                    text: "ES Return",
                                    link: "/Dashboard",
                                    /*subMenu: [
                                        {
                                            text: "ES1",
                                            link: "/ES1",
                                        },
                                        {
                                            text: "ES2",
                                            link: "/ES2",
                                        },
                                        {
                                            text: "ES3",
                                            link: "/ES3",
                                        },
                                        {
                                            text: "ES4",
                                            link: "/ES4",
                                        },
                                        {
                                            text: "ESS-Part1",
                                            link: "/ES5Part1",
                                        },
                                        {
                                            text: "ESS-Part2",
                                            link: "/ES5Part2",
                                        },
                                    ]*/
                                },

                            ]

                        },


                    ]

export default menu;
